import { useState } from 'react';

function MessageButton({ 
    recipientId, 
    recipientName, 
    className = '', 
    size = 'medium',
    variant = 'primary',
    disabled = false,
    onMessageSent = null
}) {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (disabled || isLoading) return;
        
        // Fire custom event to open message modal
        const event = new CustomEvent('openMessageModal', {
            detail: {
                recipientId,
                recipientName,
                onMessageSent
            }
        });
        window.dispatchEvent(event);
    };

    const getSizeClass = () => {
        switch (size) {
            case 'small': return 'btn-sm';
            case 'large': return 'btn-lg';
            case 'icon': return 'btn-icon';
            default: return '';
        }
    };

    const getVariantClass = () => {
        switch (variant) {
            case 'secondary': return 'btn-secondary';
            case 'outline': return 'btn-outline';
            default: return 'btn-primary';
        }
    };

    return (
        <button
            onClick={handleClick}
            disabled={disabled || isLoading}
            className={`base-btn message-btn ${getSizeClass()} ${getVariantClass()} ${className}`}
            title={`Send message to ${recipientName}`}
            aria-label={`Send message to ${recipientName}`}
        >
            <svg 
                className="message-icon" 
                width={size === 'icon' ? 16 : 16} 
                height={size === 'icon' ? 16 : 16} 
                viewBox="0 0 24 24" 
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"/>
                <path d="M7 9H17V11H7V9Z"/>
                <path d="M7 12H13V14H7V12Z"/>
            </svg>
            {(size !== 'icon') && <span className="message-text">Message</span>}
        </button>
    );
}

export default MessageButton;
